/*
 *
 * Customer constants
 *
 */

export const UPDATE_CUSTOMER = 'app/Customer/UPDATE_CUSTOMER'
export const UPDATE_CUSTOMER_SUCCESS = 'app/Customer/UPDATE_CUSTOMER_SUCCESS'
export const UPDATE_CUSTOMER_ERROR = 'app/Customer/UPDATE_CUSTOMER_ERROR'
